/**
 * The gateway access token, held in memory only.
 *
 * It used to live in the `a_token` cookie, which meant every request carried it
 * twice - once in `Authorization`, once in `Cookie`. An Entra access token
 * carrying `groups`, `wids` and a `/.default` `scp` list runs to roughly 4 KB,
 * so the duplicate pushed the request past the gateway's 8 KB header limit and
 * came back as a bare 400. Nothing outside this module needs the raw token, and
 * MSAL's own cache survives reloads, so memory is enough.
 */
let currentToken: string | null = null;

export function setStoredToken(token: string | null) {
  currentToken = token;
}

export function getStoredToken(): string {
  return currentToken ?? '';
}
